import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoveToInboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"move_to_inbox"}/>
}
